import { validateFeatureFlag } from '../../services/featureFlagService';
import { FEATURE_FLAG } from '../../constants/general';
import { PlanUpgradeBlock } from './blocks/PlanUpgradeBlock';
import { TransactionLimitBlock } from './blocks/TransactionLimitBlock';
import { LegalDocsBlock } from './blocks/LegalDocsBlock';
import { AccountSwitcherBlock } from './blocks/AccountSwitcherBlock';
import { LogoutBlock } from './blocks/LogoutBlock';
import { AccountDetailsBlock } from './blocks/AccountDetailsBlock';
import { RoleType, ISummaryData } from '../../types';
import { IClientResponse } from '../../flows/profile/components/accountant-account-switcher/types';
import { AccountSettingsBlock } from './blocks/AccountSettingsBlock';
import { LiliPlanType } from '../../flows/planUpgrade/constants';

export const buildProfileBlocks = (summaryData: ISummaryData) => {
  const shouldRenderAccountSwitch = () => {
    const businessList = summaryData?.otherBusinesses;
    const { actionFlags } = summaryData;
    const isFeatureOpen = validateFeatureFlag(FEATURE_FLAG.ADD_NEW_BUSINESS);

    if (summaryData.authorizedUserData) {
      const combinedLists: IClientResponse[] = [
        ...(summaryData.authorizedUserData?.authorizedUserInvites || []),
        ...(summaryData.authorizedUserData?.authorizedUserPendingInvites || []),
      ];
      return combinedLists.length > 1;
    }

    if (businessList?.length) return true;
    return !!(isFeatureOpen && (actionFlags?.businessInProgress || actionFlags?.allowAdditionalBusiness));
  };

  const blocksMap = [
    {
      id: 1,
      order: 1,
      isFeatureFlagValid: true,
      disabledForRoles: [''],
      disabledForPlans: [''],
      component: AccountDetailsBlock,
      conditionalRender: true,
      shouldAvoidWrapperPadding: false,
      isShown: true,
    },
    {
      id: 2,
      order: 2,
      isFeatureFlagValid: validateFeatureFlag(FEATURE_FLAG.PLAN_UPGRADE),
      disabledForRoles: [RoleType.ACCOUNTANT],
      disabledForPlans: [LiliPlanType.PREMIUM],
      component: PlanUpgradeBlock,
      conditionalRender: true,
      shouldAvoidWrapperPadding: true,
      isShown: true,
    },
    {
      id: 'account-settings',
      order: 3,
      isFeatureFlagValid: true,
      disabledForRoles: [''],
      disabledForPlans: [''],
      component: AccountSettingsBlock,
      conditionalRender: true,
      shouldAvoidWrapperPadding: false,
      isShown: true,
    },
    {
      id: 4,
      order: 4,
      isFeatureFlagValid: true,
      disabledForRoles: [RoleType.ACCOUNTANT],
      disabledForPlans: [''],
      component: TransactionLimitBlock,
      conditionalRender: true,
      shouldAvoidWrapperPadding: false,
      isShown: true,
    },
    {
      id: 5,
      order: 5,
      isFeatureFlagValid: true,
      disabledForRoles: [RoleType.ACCOUNTANT],
      disabledForPlans: [''],
      component: LegalDocsBlock,
      conditionalRender: true,
      shouldAvoidWrapperPadding: false,
      isShown: false,
    },
    {
      id: 6,
      order: 6,
      isFeatureFlagValid: true,
      disabledForRoles: [''],
      disabledForPlans: [''],
      conditionalRender: shouldRenderAccountSwitch(),
      component: AccountSwitcherBlock,
      shouldAvoidWrapperPadding: false,
      isShown: true,
    },
    {
      id: 7,
      order: 7,
      isFeatureFlagValid: true,
      disabledForRoles: [''],
      disabledForPlans: [''],
      conditionalRender: true,
      component: LogoutBlock,
      shouldAvoidWrapperPadding: true,
      isShown: true,
    },
  ];

  return blocksMap
    .sort((a, b) => a.order - b.order)
    .map((item) => {
      if (!item.isFeatureFlagValid || !item.conditionalRender) {
        item.isShown = false;
      }
      if (
        !!item.disabledForRoles.length &&
        summaryData.authorizedUserType &&
        item.disabledForRoles.includes(summaryData.authorizedUserType)
      ) {
        item.isShown = false;
      }
      if (!!item.disabledForPlans && item.disabledForPlans.includes(summaryData.customerProfileInfo.customerProfile)) {
        item.isShown = false;
      }
      return item;
    });
};
